import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["type"];
import React from 'react';
import { CheckIcon, ZoomOutIcon } from '../icons';
import { palette } from '../styles';
import { Text } from '../Text';
import { Tooltip } from '../Tooltip';
import { StyledCheckbox, StyledCheckboxIcon, StyledIconWrapper, StyledInput, StyledLabel, StyledRadioIcon } from './Checkbox.styled';
export function Radio(props) {
  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
    type: "radio"
  }));
}
export function Checkbox(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange(e) {
    props.onChange && props.onChange(e.currentTarget.checked);
  };
  var Icon = type === 'checkbox' ? CheckboxIcon : RadioIcon;
  return /*#__PURE__*/React.createElement(StyledCheckbox, {
    htmlFor: props.id,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(StyledIconWrapper, {
    edited: props.edited,
    role: "combobox"
  }, /*#__PURE__*/React.createElement(StyledInput, {
    type: type,
    onClick: props.onChange ? undefined : stopClick,
    checked: props.checked || false,
    id: props.id,
    disabled: props.disabled,
    onChange: handleChange,
    name: props.name,
    tabIndex: props.tabIndex,
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby']
  }), /*#__PURE__*/React.createElement(Icon, {
    checked: props.checked,
    hasError: props.hasError,
    indeterminate: props.indeterminate || false
  })), (props.label || props.children) && /*#__PURE__*/React.createElement(StyledLabel, null, /*#__PURE__*/React.createElement(Text, null, props.label || props.children), props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip)));
}
function stopClick(event) {
  event.stopPropagation();
}
function CheckboxIcon(_ref2) {
  var checked = _ref2.checked,
    hasError = _ref2.hasError,
    indeterminate = _ref2.indeterminate;
  return /*#__PURE__*/React.createElement(StyledCheckboxIcon, {
    checked: indeterminate || checked,
    hasError: hasError
  }, indeterminate && !checked ? /*#__PURE__*/React.createElement(ZoomOutIcon, {
    size: 10,
    color: palette.white
  }) : /*#__PURE__*/React.createElement(CheckIcon, {
    size: 10,
    color: palette.white
  }));
}
function RadioIcon(_ref3) {
  var checked = _ref3.checked,
    hasError = _ref3.hasError;
  return /*#__PURE__*/React.createElement(StyledRadioIcon, {
    checked: checked,
    hasError: hasError
  }, /*#__PURE__*/React.createElement("div", null));
}